import { useEffect, useState } from "react";
import {
  collection,
  documentId,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { useParams } from "react-router-dom";
import "../styles/categories.css";
import LoadingPage from "../components/Loading";
import EnquiryCell from "../components/EnquiryCell";
import EventCell from "../components/EventCell";
import ScrollableImageList from "../components/ImageGallery";
import "../styles/event_details.css";
import { useLocation } from "react-router-dom";
import {
  fetchGalleryData,
  clearGalleryData,
} from "../features/events/events_slice";
import { useDispatch, useSelector } from "react-redux";

function EventDetails() {
  const location = useLocation();
  let { passedData } = location.state || {};
  const [eventData, setEventData] = useState([]);
  const [extraEventData, setExtraEventData] = useState([]);
  const [topEventData, setTopEventData] = useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();
  const galleryData = useSelector((state) => state.events.galleryData);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchExtraEventsData = async (eventTYpe) => {
      const q = query(
        collection(db, "events"),
        where("event_type", "==", eventTYpe),
        where("status", "==", true),
        where(documentId(), "!=", id),
        limit(4)
      );

      const querySnapshot = await getDocs(q);
      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // console.log("fetchExtraEventsData : ", items);
      setExtraEventData(items);
      if (items.length === 0) {
        fetchTopEventsData(!passedData ? items[0].type : passedData.type);
      }
    };

    const fetchTopEventsData = async (type) => {
      const q = query(
        collection(db, "events"),
        where("type", "==", type),
        where("status", "==", true),
        where(documentId(), "!=", id),
        limit(4)
      );

      const querySnapshot = await getDocs(q);
      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // console.log("fetchExtraEventsData : ", items);
      setTopEventData(items);
    };

    const fetchData = async () => {
      // console.log("passedData : ", passedData);
      let items = [];
      if (!passedData) {
        const q = query(
          collection(db, "events"),
          where(documentId(), "==", id)
        );

        const querySnapshot = await getDocs(q);
        items = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        // console.log("fetchData : ", items);
        dispatch(clearGalleryData());
        dispatch(fetchGalleryData(items[0].created_date));
        setEventData(items[0]);
      }
      fetchExtraEventsData(
        !passedData ? items[0].event_type : passedData.event_type
      );
    };
    fetchData();
    if (passedData) {
      dispatch(clearGalleryData());
      dispatch(fetchGalleryData(passedData.created_date));
    }
  }, [id, passedData, dispatch, eventData]);
  if (eventData.length !== 0) {
    passedData = eventData;
  }
  if (!passedData && eventData.length === 0) {
    return <LoadingPage />;
  }

  const getFutureTimestamps = (dateList) => {
    const now = Date.now();
    return dateList.filter((timestamp) => timestamp.start_date > now);
  };

  const formatDate = (ms) => {
    const date = new Date(ms);
    const day = date.getDate();
    const month = date.toLocaleString("en-IN", { month: "short" });
    const year = date.getFullYear().toString().slice(-2); // get last 2 digits
    return `${day} ${month} ${year}`;
  };

  return (
    <div className="event-details">
      <div className="event-container">
        <img
          src={passedData.main_image}
          alt={passedData.main_image}
          className="event-container"
        />
        <div className="event-info">
          <h2 className="event-title">{passedData.title}</h2>
          <p className="event-subtitle">{passedData.sub_title}</p>
        </div>
      </div>
      <div className="row-container">
        <div className="left-div">
          <div className="top-points">
            {!passedData.height ? <></> : <p>{passedData.height}</p>}
            {!passedData.grade || passedData.grade === "NA" ? (
              <></>
            ) : (
              <p>{passedData.grade.toUpperCase()}</p>
            )}
            {!passedData.age_limit ? <></> : <p>Age: {passedData.age_limit}</p>}
          </div>
          <p className="event-section-title">Overview</p>
          <p className="event-text">{passedData.description}</p>
          {getFutureTimestamps(passedData.avb_date_list).length !== 0 ? (
            <>
              <p className="event-section-title">Upcomming Batches</p>
              <div className="chip-container">
                {getFutureTimestamps(passedData.avb_date_list).map(
                  (ms, index) => (
                    <div key={"chip" + index} className="chip">
                      {formatDate(ms.start_date) +
                        " - " +
                        formatDate(ms.end_date)}
                    </div>
                  )
                )}
              </div>
            </>
          ) : (
            <></>
          )}
          <ScrollableImageList
            images={[
              ...galleryData,
              ...passedData.itinery.map((ite) => ite.itinerary_img),
            ]}
          />
          {passedData.highlights.length === 0 ? (
            <></>
          ) : (
            <p className="event-section-title">Highlights</p>
          )}
          <ul className="bullet-list">
            {passedData.highlights.map((item, index) =>
              !item ? <></> : <li key={index}>{item}</li>
            )}
          </ul>
          <p className="event-section-title">Itinerary</p>
          <ul className="bullet-list">
            {passedData.itinery.map((item, index) => (
              <li key={index} className="event-text">
                <h3 className="event-text-ite">{item.heading}</h3>
                <ul className="bullet-list-sub">
                  {item.sub.map((subItmes, subIndex) =>
                    !item ? <></> : <li key={subIndex}>{subItmes}</li>
                  )}
                </ul>
              </li>
            ))}
          </ul>
          {passedData.inclusions.length === 0 ? (
            <></>
          ) : (
            <p className="event-section-title">Inclusions</p>
          )}
          <ul className="bullet-list">
            {passedData.inclusions.map((item, index) =>
              !item ? (
                <></>
              ) : (
                <li key={index} className="event-text">
                  {item}
                </li>
              )
            )}
          </ul>
          {passedData.thingsToCarry.length === 0 ? (
            <></>
          ) : (
            <>
              <p className="event-section-title">Things To Carry</p>
              <ul className="bullet-list">
                {passedData.thingsToCarry.map((item, index) =>
                  !item ? (
                    <></>
                  ) : (
                    <li key={index} className="event-text">
                      {item}
                    </li>
                  )
                )}
              </ul>
            </>
          )}
        </div>
        <div className="right-div">
          {extraEventData.length === 0 ? (
            <></>
          ) : (
            <p className="event-section-title-right">
              Popular in {passedData.event_type}
            </p>
          )}
          {extraEventData.length === 0 ? (
            <></>
          ) : (
            extraEventData.map((item, index) => (
              <div className="extra-event-container" key={index}>
                <EventCell key={index} item={item} />
              </div>
            ))
          )}
          {topEventData.length === 0 ? (
            <></>
          ) : (
            <p className="event-section-title-right">Top Events</p>
          )}
          {topEventData.length === 0 ? (
            <></>
          ) : (
            topEventData.map((item, index) => (
              <div className="extra-event-container" key={index}>
                <EventCell key={index} item={item} />
              </div>
            ))
          )}
        </div>
      </div>
      <EnquiryCell
        price={passedData.price}
        name={passedData.title}
        eventId={passedData.created_date}
        dateList={passedData.avb_date_list}
      />
    </div>
  );
}

export default EventDetails;
